import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { VpButton, VpConditionalUpgradeWrapper } from '../../';
import { PLUGIN_MANAGEMENT_ENABLED } from '../../../constants/feature-keys';
import { getCurrentPluginId, setEditingPluginId } from '@src/redux/modules/pluginCreation';

export const VpAdjustPluginVideoButton = ({ _setEditingPluginId, includeAttachments, pluginId }) => {
  return (
    <VpConditionalUpgradeWrapper fullWidth featureKey={PLUGIN_MANAGEMENT_ENABLED}>
      {({ isDisabled }) => (
        <VpButton
          disabled={isDisabled}
          fullWidth
          variant="contained"
          name="adjustPluginVideosButton"
          type="submit"
          color="neutral"
          onClick={() => _setEditingPluginId(pluginId)}
        >
          {includeAttachments ? 'Adjust Content Displayed' : 'Adjust Videos Displayed'}
        </VpButton>
      )}
    </VpConditionalUpgradeWrapper>
  );
};

VpAdjustPluginVideoButton.propTypes = {
  includeAttachments: PropTypes.bool
};

const mapStateToProps = (state) => ({
  pluginId: getCurrentPluginId(state),
});
const mapDispatchToProps = {
  _setEditingPluginId: setEditingPluginId
};

export default connect(mapStateToProps, mapDispatchToProps)(VpAdjustPluginVideoButton);



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginDetailsForm/VpAdjustPluginVideoButton.jsx